import { useQuery, useQueryClient, keepPreviousData } from "@tanstack/react-query";
import { trainersApi } from "../trainers/trainersApi";
import { QUERIES_KEYS } from "queries";

export const useTrainerGroups = (
  skip: number,
  limit: number,
  searchPhrase: string = "",
  filter: string = "",
  orderBy: string = "",
) => {
  const queryClient = useQueryClient();
  const { isLoading, isFetching, data } = useQuery({
    queryKey: QUERIES_KEYS.TRAINER_GROUPS(skip, limit, searchPhrase, filter, orderBy),
    queryFn: () => trainersApi.fetchGroups(skip, limit, searchPhrase, filter, orderBy),
    placeholderData: keepPreviousData,
  });

  const invalidate = () => {
    queryClient.invalidateQueries({
      queryKey: QUERIES_KEYS.TRAINER_GROUPS(skip, limit, searchPhrase, filter, orderBy),
    });
  };

  return { invalidate, isLoading, isFetching, trainerGroups: data?.data.data ?? [], total: data?.data.total ?? 0 };
};

export const useTrainerGroupsOptions = () => {
  const { isLoading, trainerGroups } = useTrainerGroups(0, 1_000_000);

  return {
    loading: isLoading,
    options: trainerGroups.map((x) => ({
      value: x.id.toString(),
      label: x.name,
    })),
  };
};
